import { Container, Row, Col, Button, Form } from '@themesberg/react-bootstrap';
import React, { useState, useEffect } from 'react';
import { post, get } from '../../../services/back.service';
import { uploadWithSignedUrl } from '../../../utils/uploadSignedUrl';
import useAutosave from '../../../hooks/useAutosave';

const FormScannerSheetReport = ({ id }) => {
  const [bodyImages, setbodyImages] = useState([]);
  const [msgButton, setMsgButton] = useState('Guardar Informacion')

  const autosave = useAutosave(async () => {
    const images = bodyImages.map(({ base64, ...rest }) => rest);
    await post('/peritaje/modifyinspection/attach/' + id, {
      type: 'SS',
      images
    });
  });

  const updateImages = (name, value) => {
    const tmImages = bodyImages;
    const index = tmImages.findIndex((e) => e.name === name);
    if (index >= 0) {
      tmImages[index] = { ...value, name };
    } else {
      tmImages.push({ ...value, name });
    }
    setbodyImages([...tmImages])
    autosave.schedule();
  };

  const getCurrentImage = (name) => {
    const image = bodyImages.find((e) => e.name === name);
    if (image) {
      return image.base64
    } else {
      return ''
    }
  }

  const deleteImage = (name) => {
    const input = document.getElementById(name);
    input.value = null;
    const index = bodyImages.findIndex((e) => e.name === name);
    bodyImages.splice(index, 1);
    setbodyImages([...bodyImages]);
  };

  const showConvertImage = async (e, name) => {
    const currentFile = e.target.files[0];
    try {
      const metadata = await uploadWithSignedUrl(currentFile, id, 'SS', 'attach', name);
      const preview = URL.createObjectURL(currentFile);
      updateImages(name, { ...metadata, name, base64: preview });
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };

  const sendInfo = async (event) => {
    event.preventDefault();
    autosave.cancel();
    const images = bodyImages.map(({ base64, ...rest }) => rest);
    const body = {
      type: 'SS',
      images
    };
    const respo = await post('/peritaje/modifyinspection/attach/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    }
  };

  useEffect(() => {
    const initForm = async () => {
      const respo = await get('/peritaje/downloadimages/SS/' + id, {});
      if (respo.success) {
        setbodyImages(respo.data);
      }
    };
    initForm();
  }, [id]);

  return (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">Hojas De Escaner</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col>
          <div>
            <div>
              <br />
              {getCurrentImage('scannerSheet') !== '' && <Button
                variant="outline-primary"
                onClick={() => deleteImage('scannerSheet')}
              >
                Remover
              </Button>}
            </div>
            <Form.Group>
              <Form.Control
                type="file"
                id="scannerSheet"
                name="scannerSheet"
                accept="application/pdf"
                onChange={(e) => { showConvertImage(e, 'scannerSheet'); }}
              />
            </Form.Group>
          </div>
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default FormScannerSheetReport;
